import React from "react";
import '../../App.css';
import { useOutletContext } from "react-router-dom";



function Pricing() {

    return  <>  
    <div>
    <h1>Pricing welcomes you</h1>
    </div>
   
     </>
}

export default Pricing;